import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelService<T> {
  exportExcel(data: T[], fileName: string, skipHeader: boolean = false): void {
    const worksheet: any = XLSX.utils.json_to_sheet(data, { skipHeader });
    const workbook = {
      Sheets: { data: worksheet },
      SheetNames: ['data'],
    };
    const buffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const blob: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  }
}
